import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c795095a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders-in-delivery-view" }
const _hoisted_2 = {
  key: 0,
  class: "orders"
}
const _hoisted_3 = { class: "order__title title" }
const _hoisted_4 = { class: "title__title rouble-symbol" }
const _hoisted_5 = {
  key: 0,
  class: "title__title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title__circle" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title__info" }, null, -1))
const _hoisted_8 = { class: "order__additional-info additional-info" }
const _hoisted_9 = { class: "additional-info__row row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Получатель ", -1))
const _hoisted_11 = { class: "row__description row__description--bold" }
const _hoisted_12 = { class: "additional-info__row row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Время заказа ", -1))
const _hoisted_14 = { class: "row__description row__description--bold" }
const _hoisted_15 = {
  key: 0,
  class: "additional-info__row row"
}
const _hoisted_16 = { class: "row__title" }
const _hoisted_17 = { class: "row__description row__description--bold" }
const _hoisted_18 = { class: "additional-info__row row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Телефон ", -1))
const _hoisted_20 = { class: "row__description" }
const _hoisted_21 = {
  key: 1,
  class: "additional-info__row row delivery-address-row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Адрес доставки ", -1))
const _hoisted_23 = { class: "row__description" }
const _hoisted_24 = {
  key: 2,
  class: "additional-info__row row"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Адрес самовывоза ", -1))
const _hoisted_26 = { class: "row__description" }
const _hoisted_27 = {
  key: 3,
  class: "additional-info__row row"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Комментарий к заказу ", -1))
const _hoisted_29 = { class: "row__description" }
const _hoisted_30 = { class: "additional-info__row row row--small-offset" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Сумма заказа ", -1))
const _hoisted_32 = { class: "row__description row__description--large rouble-symbol" }
const _hoisted_33 = {
  key: 4,
  class: "additional-info__row row row--small-offset"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Скидка по акции ", -1))
const _hoisted_35 = { class: "row__description row__description--large rouble-symbol" }
const _hoisted_36 = {
  key: 5,
  class: "additional-info__row row row--small-offset"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Оплачено баллами ", -1))
const _hoisted_38 = { class: "row__description row__description--large" }
const _hoisted_39 = {
  key: 6,
  class: "additional-info__row row row--small-offset"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Доставка ", -1))
const _hoisted_41 = { class: "row__description" }
const _hoisted_42 = { class: "additional-info__row row row--small-offset" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Оплачено ", -1))
const _hoisted_44 = { class: "row__description row__description--large rouble-symbol" }
const _hoisted_45 = { class: "additional-info__row row row--small-offset" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " К оплате ", -1))
const _hoisted_47 = { class: "row__description row__description--large row__description--red rouble-symbol" }
const _hoisted_48 = {
  key: 7,
  class: "additional-info__row row row--small-offset bonuses-accrual-row"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, " Будет начислено баллов ", -1))
const _hoisted_50 = { class: "row__description row__description--large" }
const _hoisted_51 = {
  key: 0,
  class: "order__process-btn"
}
const _hoisted_52 = { class: "order__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _component_EmptyLayout = _resolveComponent("EmptyLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.wasLoaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.orders.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: order.id,
                    class: "orders__item order"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, " Заказ №" + _toDisplayString(order.id) + " на сумму " + _toDisplayString(order.totalPrice), 1),
                      (order.deliveryAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(_ctx.DELIVERY_TITLES[order.deliveryTypeId]) + " " + _toDisplayString(_ctx.getOrderDate(order)) + ") ", 1))
                        : _createCommentVNode("", true),
                      _hoisted_6,
                      _createElementVNode("span", {
                        class: _normalizeClass(["title__status", {
                'title__status--green':
                  order.status === _ctx.ORDER_STATUS.IN_DELIVERY,
              }])
                      }, _toDisplayString(_ctx.ORDER_TITLE_STATUS[order.status]), 3),
                      _createVNode(_component_Dropdown, null, {
                        popper: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _hoisted_10,
                              _createElementVNode("div", _hoisted_11, _toDisplayString(order.customerFullName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$filters.formattedDateTime(order.acceptedAt)), 1)
                            ]),
                            (order.deliveryAt)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    (order.deliveryTypeId === _ctx.DELIVERY_TYPE.COURIER)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" Доставка ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" Самовывоз ")
                                        ], 64))
                                  ]),
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$filters.formattedDateTime(order.deliveryAt)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("div", _hoisted_20, _toDisplayString(order.customerPhone), 1)
                            ]),
                            (
                      order.deliveryTypeId === _ctx.DELIVERY_TYPE.COURIER
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(order.deliveryAddress), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (order.deliveryTypeId === _ctx.DELIVERY_TYPE.SELF_PICKUP)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(order.pickupAddress), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (order.notes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(order.notes), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$filters.formattedNumber(order.totalPriceWithoutDiscount)), 1)
                            ]),
                            (+order.totalDiscount > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, " -" + _toDisplayString(_ctx.$filters.formattedNumber(order.totalDiscount)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (+order.bonusesWriteOffSum > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("div", _hoisted_38, " -" + _toDisplayString(_ctx.$filters.formattedNumber(order.bonusesWriteOffSum)) + " ББ ", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (order.deliveryTypeId === _ctx.DELIVERY_TYPE.COURIER)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _hoisted_40,
                                  _createElementVNode("div", _hoisted_41, [
                                    (order.deliveryPrice > 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$filters.formattedNumber(order.deliveryPrice)), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" Бесплатно ")
                                        ], 64))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$filters.formattedNumber(order.sumPaid)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$filters.formattedNumber(order.sumToPay)), 1)
                            ]),
                            (+order.bonusesAccrualSum > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  _hoisted_49,
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$filters.formattedNumber(order.bonusesAccrualSum)) + " ББ ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    (_ctx.isAvailableForPayment(order))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createVNode(_component_router_link, {
                            to: { name: 'c-orders-in-delivery-payment', params: { orderId: order.id }},
                            class: "coupon__btn base-btn base-btn--default"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Оплатить заказ ")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items, (orderItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: orderItem.id,
                          class: "order-item"
                        }, [
                          _createVNode(_component_ProductItem, {
                            quantity: orderItem.quantity,
                            image: orderItem.product.image,
                            name: orderItem.product.name,
                            description: orderItem.productOption?.description,
                            weight: orderItem.productOption?.weight,
                            price: orderItem.price,
                            "price-without-discount": orderItem.priceWithoutDiscount
                          }, null, 8, ["quantity", "image", "name", "description", "weight", "price", "price-without-discount"])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(_component_EmptyLayout, {
                key: 1,
                title: "У вас нет активных доставок"
              }))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}